import { clsx } from "clsx"

interface Props {
    className?: string
    [x: string]: unknown
}

export function Container({ className, ...props }: Props) {
    return <div className={clsx("mx-auto max-w-7xl px-4 sm:px-6 lg:px-8", className)} {...props} />
}
